// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import { ThemeProvider } from '@mui/material/styles';
// import theme from './theme';
// ReactDOM.render(
//   <React.StrictMode>
//     <ThemeProvider theme={theme}>
//       <App />
//     </ThemeProvider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import '@fontsource/mulish/300.css'; // Light
import '@fontsource/mulish/400.css'; // Regular
import '@fontsource/mulish/500.css'; // Medium
import '@fontsource/mulish/600.css'; // SemiBold
import '@fontsource/mulish/700.css'; // Bold
import '@fontsource/mulish/800.css'; // ExtraBold
import theme from './theme';
ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);